"use strict";
exports.__esModule = true;
exports.WebsdkAllavailabilitiesHelperService = void 0;
var websdk_allavailabilities_api_1 = require("./websdk-allavailabilities.api");
var fetchAllAvailabilities = function (params) {
    var url = websdk_allavailabilities_api_1.AllAvailabilitiesApi.get(params);
    if (url === null) {
        return Promise.resolve({ error: true, data: null });
    }
    return fetch(url, { method: 'GET' })
        .then(function (res) { return res.json(); });
};
exports.WebsdkAllavailabilitiesHelperService = { fetchAllAvailabilities: fetchAllAvailabilities };
//# sourceMappingURL=websdk-allavailabilities-helper.service.js.map